import { render, staticRenderFns } from "./BookingDetailsWrapper.vue?vue&type=template&id=852ae9fa&lang=pug&"
import script from "./BookingDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./BookingDetailsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports